
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">اضافة انجاز للمشروع</h5>

                       <span style="font-size: large;"> {{ProjectName}} </span>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form [formGroup]="insertForm" (ngSubmit)="Submit()">

                    <div class="row m-0 mb-2">
                        <div class="col-md-6">
                          <label for=""> عنوان الانجاز
                          </label>
                            <div class="form-group">
                               <input type="text"  class="form-control" formControlName="title" 
                               [tooltip]="fc.title.errors?.required ? ' عنوان الانجاز مطلوب' : null" required
                               [isDisabled]="!((fc.title.errors?.required && fc.title.touched))"
                               containerClass="" [class.is-valid]="fc.title.valid && (fc.title.touched)"
                               [class.is-invalid]="fc.title.invalid && (fc.title.touched)"
                               >
                            </div>
                        </div>
                        <div class="col-md-6">
                          <label for=""> نسبة انجاز  المشروع (%)</label>
                          <!-- <div class="input-group">
                            <input class="form-control" type="text" placeholder="Recipient's username" aria-label="Recipient's username">
                            <div class="input-group-append"><span class="input-group-text">٪</span></div>
                          </div> -->
                          <div class="form-group">
                            <div class="input-group">
                              <div class="input-group-append"><span class="input-group-text">%</span></div>

                               <input type="number"  class="form-control" formControlName="completionPercent" 
                               [tooltip]="fc.completionPercent.errors?.required ? ' نسبة انجاز  المشروع مطلوب' : null" required
                               [isDisabled]="!((fc.completionPercent.errors?.required && fc.completionPercent.touched))"
                               containerClass="" [class.is-valid]="fc.completionPercent.valid && (fc.completionPercent.touched)"
                               [class.is-invalid]="fc.completionPercent.invalid && (fc.completionPercent.touched)"
                               >

                            </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                          <label for=""> وصف الانجاز
                          </label>
                            <div class="form-group">
                               <textarea type="text"  class="form-control" style="height: 100px;" formControlName="description" 
                               [tooltip]="fc.description.errors?.required ? ' وصف الانجاز مطلوب' : null" required
                               [isDisabled]="!((fc.description.errors?.required && fc.description.touched))"
                               containerClass="" [class.is-valid]="fc.description.valid && (fc.description.touched)"
                               [class.is-invalid]="fc.description.invalid && (fc.description.touched)"
                               ></textarea>
                            </div>
                        </div>
                        <div class="col-lg-6 col-sm-12  mb-3" style="margin-top: 7px;">
                          <label for="">المحافظة</label>
                          <!-- <div class="form-group"> -->
                              <ng-multiselect-dropdown
                             
                              [placeholder]="'اختر المحافظة'"
                              [settings]="dropdownSettings"
                              [data]="Governates"
                              [(ngModel)]="selectedItemsGovernates" 
                              [ngModelOptions]="{standalone: true}"   >
                                        </ng-multiselect-dropdown>
                          <!-- </div> -->
                        </div> 
                        <!-- <div class="col-md-6  text-center" style="padding-top: 10px;">
                          <label for=""> اسم المشروع
                          </label>
                          <p>{{ProjectName}}</p>
                          
                        </div> -->
                       
                      <!-- insert image -->
                      <div class="col-6 my-3 " >
                        <img  src="{{ imageproject }}" style="width: 60%; height: 220px;" class="image-style p-2" />
                       <input type="file" formControlName="projectcompletionimage" accept="image/*" #file id="getLogo"
                        style="display: none" (change)="getLogoUrl($event)" />
                    <button type="button" onclick="document.getElementById('getLogo').click()"
                        class="btn   d-block"  style="width: 60%;">
                        ارفاق صورة
                    </button>    
                                </div>
                   
                        <div class="col-12 col-md-12">
                            <div *ngIf="update; else elseBlock">
                                <button class="btn  pull-right" type="submit" >
                                  تعديل
                                </button>
                              </div>
                  
                              <ng-template #elseBlock>
                                <button class="btn  pull-right" type="submit">
                                  إضافة
                                </button>
                              </ng-template>
                </div>
                </div>
                    </form>
    </div>
</div>
        </div>
    </div>
</div>